const Tool = (props) => {
  return (
    <div className="tool">
      <img className="tool__logo" alt="logo" src={props.logo} />
      <p className="tool__name">{props.tool}</p>
    </div>
  );
};

export default Tool;
